<ca-modal-container
    [modalTitle]="'APPLICATIONS.CREATE_APPLICATION_DIALOG.TITLE' | translate"
    (dismiss)="dismiss()"
    data-uit="create-application-dialog"
    *ngrxLet="vm$$; let vm"
>
    <form #createApplicationForm="ngForm" (ngSubmit)="submit()" autocomplete="off">
        <div class="row">
            <div class="col-1 pe-0">
                <div class="dot mt-1" [ngClass]="{ 'is-checked': applicationName }"></div>
                <div class="vertical-line-1 ms-2" [ngClass]="{ 'vertical-line-filled': applicationName && selectedModel }"></div>
            </div>
            <div class="col ps-0">
                <div class="d-flex flex-column-reverse">
                    <input
                        labelforid="name"
                        type="text"
                        class="form-control"
                        data-uit="application-name-input"
                        [(ngModel)]="applicationName"
                        name="applicationName"
                        required
                        [placeholder]="'APPLICATIONS.CREATE_APPLICATION_DIALOG.NAME_PLACEHOLDER' | translate"
                        [ngClass]="createApplicationForm.dirty && createApplicationForm.form.invalid ? 'has-error' : ''"
                        required
                    />
                    <label for="name">{{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.NAME_APPLICATION' | translate }}<span class="red ps-1">*</span></label>
                </div>
                <small *ngIf="createApplicationForm.dirty && createApplicationForm.form.invalid" class="invalid-feedback">
                    {{ 'GENERAL.REQUIRED_FIELD' | translate }}
                </small>
            </div>
        </div>
        <div class="row">
            <div class="col-1 pe-0">
                <div class="dot" [ngClass]="{ 'is-checked': selectedModel }"></div>
                <div
                    class="vertical-line-2 ms-2"
                    [ngClass]="{
                        'vertical-line-2-model-properties': selectedModel,
                        'vertical-line-filled': selectedModel && selectedMeasurements.length > 0,
                    }"
                ></div>
            </div>
            <div class="col ps-0">
                <ca-list-progress-bar
                    *ngIf="vm.allMachineLearningModelsState$?.loadingState === 'LOADING'"
                    [isShown]="vm.allMachineLearningModelsState$?.loadingState === 'LOADING'"
                    [label]="'APPLICATIONS.CREATE_APPLICATION_DIALOG.LOADING_TRAINING_MODELS' | translate"
                ></ca-list-progress-bar>
                <ng-container *ngIf="vm.allMachineLearningModelsState$?.loadingState === 'LOADED' && vm.allMachineLearningModelsState$?.data">
                    <div class="d-flex flex-column-reverse form-group">
                        <ng-select
                            tabindex="0"
                            labelforid="training"
                            [items]="vm.allMachineLearningModelsState$?.data"
                            [(ngModel)]="selectedModel"
                            name="selectedModel"
                            appendTo="body"
                            [placeholder]="'APPLICATIONS.CREATE_APPLICATION_DIALOG.SELECT_TRAINING_MODEL_PLACEHOLDER' | translate"
                            bindLabel="name"
                            [clearable]="false"
                            [searchable]="true"
                            data-uit="ml-model-selector"
                        >
                            <ng-template ng-label-tmp let-model="item">
                                {{ model.modelName }} [{{ model.modelVersionName }}] ({{ model.createdAt | date: 'dd.MM.yyyy | hh:mm:ss' }})
                            </ng-template>
                            <ng-template ng-option-tmp let-model="item">
                                <div class="d-flex align-items-center justify-content-between" style="justify-content: space-between">
                                    {{ model.modelName }} [{{ model.modelVersionName }}] ({{ model.createdAt | date: 'dd.MM.yyyy | hh:mm:ss' }})
                                    <div class="me-4">
                                        {{ !isUserOwner(model.userId) ? ('MY_WORKSPACE.MY_RESULTS.SHARING.MODULE_SELECTION_ADDITION' | translate) : '' }}
                                    </div>
                                </div>
                            </ng-template>
                        </ng-select>
                        <label for="training">{{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.SELECT_TRAINING_MODEL' | translate }}</label>
                    </div>
                    <div *ngIf="selectedModel" class="mt-3">
                        <div class="row mx-0">
                            <div class="col px-0 py-1 subtitle">{{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.MODEL.PROPERTIES' | translate }}</div>
                        </div>
                        <div class="row">
                            <div class="col border-top ms-3 me-1 px-0 py-1">
                                {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.MODEL.TYPE' | translate }}:
                                <span class="model-value ps-1">{{ selectedModel.trainingType }}</span>
                            </div>
                            <div class="col border-top me-3 ms-1 px-0 py-1">
                                {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.MODEL.BIT_DEPTH' | translate }}:
                                <ng-container *ngIf="selectedModel.bitSize != null"
                                    ><span class="model-value ps-1">{{ selectedModel.bitSize }}</span></ng-container
                                >
                            </div>
                        </div>
                        <div class="row">
                            <div class="col border-top ms-3 me-1 px-0 py-1">
                                {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.MODEL.CLASSES' | translate }}:
                                <span class="model-value ps-1">{{ selectedModel.classes!.join(', ') }}</span>
                            </div>
                            <div class="col border-top me-3 ms-1 px-0 py-1">
                                {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.MODEL.CHANNELS' | translate }}:
                                <ng-container *ngIf="selectedModel.numberOfChannels != null"
                                    ><span class="model-value ps-1"
                                        >{{ selectedModel.numberOfChannels
                                        }}{{
                                            'MACHINE_LEARNING.TRAIN.RESULT.DETAIL_INFO.NUMBER_OF_CHANNELS_SUFFIX' +
                                                (selectedModel.numberOfChannels === 1 ? '' : '_PLURAL') | translate
                                        }}</span
                                    ></ng-container
                                >
                            </div>
                        </div>
                        <div class="row">
                            <div class="col border-top ms-3 me-1 px-0 py-1">
                                {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.MODEL.OVERLAP' | translate }}:
                                <span class="model-value ps-1">
                                    {{
                                        'MACHINE_LEARNING.TRAIN.RESULT.DETAIL_INFO.ANNOTATION_CLASSES_OVERLAP.' +
                                            (selectedModel.classesOverlap ? 'TRUE' : 'FALSE') | translate
                                    }}</span
                                >
                            </div>
                            <div class="col border-top me-3 ms-1 px-0 py-1">
                                {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.MODEL.MINIMAL_IMG_SIZE' | translate }}:
                                <ng-container *ngIf="selectedModel.pixelSizeX != null && selectedModel.pixelSizeY != null">
                                    <span class="model-value ps-1">
                                        {{ selectedModel.pixelSizeX }} * {{ selectedModel.pixelSizeY
                                        }}{{ 'MACHINE_LEARNING.TRAIN.RESULT.DETAIL_INFO.PIXEL_SIZE_SUFFIX' | translate }}
                                    </span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <span *ngIf="vm.allMachineLearningModelsState$?.errorState?.errorMsg as errorMsg" class="text-warning">
                    {{ errorMsg | translate }}
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-1 pe-0"><div class="dot" [ngClass]="{ 'is-checked': selectedMeasurements.length > 0 && selectedModel }"></div></div>
            <div class="col ps-0">
                <ca-list-progress-bar
                    *ngIf="vm.measurementsState$?.loadingState === 'LOADING' && selectedModel"
                    [isShown]="vm.measurementsState$?.loadingState === 'LOADING'"
                    [label]="'APPLICATIONS.CREATE_APPLICATION_DIALOG.LOADING_MEASUREMENTS' | translate"
                ></ca-list-progress-bar>
                <ng-container *ngIf="vm.measurementsState$?.loadingState === 'LOADED' && selectedModel" labelforid="measurements">
                    <label for="measurements">{{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.SELECT_MEASUREMENTS' | translate }}</label>
                    <p class="subtitle mb-1">
                        {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.PREDEFINED_SUBTITLE' | translate }}
                        <span [ngbTooltip]="'APPLICATIONS.CREATE_APPLICATION_DIALOG.PREDEFINED_DESC' | translate" class="red ps-1 cursor-pointer">*</span>
                    </p>
                    <ng-container *ngIf="selectedModel && vm.measurementsState$.data">
                        <div class="d-flex align-items-center" *ngFor="let measurement of vm.measurementsState$.data">
                            <ca-input-checkbox
                                class="me-1 checkbox-alignment"
                                [checked]="measurement.selected"
                                (change)="toggleMeasurement(measurement)"
                                data-uit="measurement-checkbox"
                                >{{ measurement.child.name }}</ca-input-checkbox
                            ><ca-icon
                                *ngIf="measurement.child.description"
                                name="info"
                                size="s"
                                class="ca-color-icon-info info-icon"
                                [removeSVGAttributes]="['stroke']"
                                [ngbTooltip]="measurement.child.description"
                            ></ca-icon>
                        </div>
                        <div class="d-flex align-items-center">
                            <span>{{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.LOOKING_FOR_DIFFERENT_MEASUREMENT' | translate }}</span>
                            <button type="button" class="btn btn-ghost ps-2 pe-1 py-0 ms-1 btn-request-measurement underline" (click)="requestMlMeasurement()">
                                {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.SEND_MEASUREMENT_REQUEST' | translate
                                }}<ca-icon class="ms-2" name="envelope" size="s"></ca-icon>
                            </button>
                        </div>
                    </ng-container>
                </ng-container>
                <span *ngIf="vm.measurementsState$?.errorState?.errorMsg as errorMsg" class="text-warning">
                    {{ errorMsg | translate }}
                </span>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col">
                <div class="modal-buttons">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        [disabled]="
                            !createApplicationForm.dirty ||
                            createApplicationForm.form.invalid ||
                            !selectedModel ||
                            (selectedMeasurements.length === 0 && (!useMyWorkflow || !selectedWorkflow))
                        "
                        caAutoFocus
                        data-uit="create-application-btn"
                    >
                        {{ 'APPLICATIONS.CREATE_APPLICATION_DIALOG.CREATE' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</ca-modal-container>
